import {
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Hidden,
} from "@mui/material";
import LabelInput from "../../../components/input/LabelInput";
import { useTranslation } from "react-i18next";
import { common, input } from "../../../i18n";
import {
  AddEmissionContext,
  InputAmountType,
} from "../../../contexts/AddEmissionContext";
import { useEffect } from "react";

interface Props {
  activityGroup: string | undefined;
  activityAttribute: string | undefined;
}

export const InputAmountTypeRadio = ({
  activityGroup,
  activityAttribute,
}: Props): JSX.Element => {
  const { t } = useTranslation([common, input], {
    nsMode: "fallback",
  });

  const { inputAmountType, setInputAmountType, isDisabledAuxInput } =
    AddEmissionContext();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputAmountType(event.target.value as InputAmountType);
  };

  useEffect(() => {
    setInputAmountType("normal");
  }, []);

  return (
    <>
      {(activityAttribute === "Uncoated printing paper" ||
        activityGroup === "Waste Disposal") &&
      !isDisabledAuxInput ? (
        <Grid item xs={12} md={6}>
          <FormControl>
            <LabelInput
              label={t("What-Type-Of-Data-Do-You-Have")}
              info={t("What-Type-Of-Data-Do-You-Have")}
              required
            />
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              sx={{
                margin: "8px 0px",
                gap: { xs: "20px", sm: "40px" },
              }}
              value={inputAmountType}
              onChange={handleChange}
            >
              <FormControlLabel
                control={<Radio />}
                label={
                  activityAttribute === "Uncoated printing paper"
                    ? t("Amount-of-Purchases")
                    : activityGroup === "Waste Disposal"
                    ? t("Amount-Of-Waste")
                    : ""
                }
                value="normal"
              />
              <FormControlLabel
                control={<Radio />}
                label={
                  activityAttribute === "Uncoated printing paper"
                    ? t("Size-And-Weight")
                    : activityGroup === "Waste Disposal"
                    ? t("Person-On-site")
                    : ""
                }
                value="special"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      ) : (
        <Hidden mdDown>
          <Grid item xs={0} md={6}></Grid>
        </Hidden>
      )}
    </>
  );
};
